export class OrderItemRefundSummary {
  public constructor(
    private readonly data: {
      originalPrice: number;
      refundedPrice: number;
      currentPrice: number;
      originalQuantity: number;
      refundedQuantity: number;
      currentQuantity: number;
      fullyRefunded: boolean;
    },
  ) {}

  public get originalPrice(): number {
    return this.data.originalPrice;
  }

  public get refundedPrice(): number {
    return this.data.refundedPrice;
  }

  public get currentPrice(): number {
    return this.data.currentPrice;
  }

  public get originalQuantity(): number {
    return this.data.originalQuantity;
  }

  public get refundedQuantity(): number {
    return this.data.refundedQuantity;
  }

  public get currentQuantity(): number {
    return this.data.currentQuantity;
  }

  public get fullyRefunded(): boolean {
    return this.data.fullyRefunded;
  }
}
